import { appDependencies } from "../AppDependencies";
import { INavigator } from "./INavigator";

export class Navigator implements INavigator {
    navigateTo(url: string, params?: any) {
        appDependencies.INavigateTo.go(url, params);
    }
    reload() {
        appDependencies.INavigateTo.reload();
    }
}
